import { render, staticRenderFns } from "./lectureDetails.vue?vue&type=template&id=36aaffed&scoped=true&"
import script from "./lectureDetails.vue?vue&type=script&lang=js&"
export * from "./lectureDetails.vue?vue&type=script&lang=js&"
import style0 from "./lectureDetails.vue?vue&type=style&index=0&id=36aaffed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aaffed",
  null
  
)

export default component.exports